export const APP_VERSION = "2.3.2";
export const APP_UPDATED = "8 Apr 2026";
